import { render } from "./teamwork-page.vue?vue&type=template&id=6caf166f&scoped=true"
const script = {}

import "./teamwork-page.vue?vue&type=style&index=0&id=6caf166f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6caf166f"
/* hot reload */
if (module.hot) {
  script.__hmrId = "6caf166f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6caf166f', script)) {
    api.reload('6caf166f', script)
  }
  
  module.hot.accept("./teamwork-page.vue?vue&type=template&id=6caf166f&scoped=true", () => {
    api.rerender('6caf166f', render)
  })

}

script.__file = "html/vue/teamwork-page.vue"

export default script